import React, { Component } from 'react';

import Input from '../../components/Form/Input/Input';
import Button from '../../components/Button/Button';
import { required, length, email } from '../../util/validators';
import Auth from './Auth';

class Signup extends Component {
  state = {
    signupForm: {
      email: {
        value: "",
        valid: false,
        errorMessage: "",
        touched: false,
        validators: [required, email],
      },
      password: {
        value: "",
        valid: false,
        errorMessage: "",
        touched: false,
        validators: [required, length({ min: 5 })],
      },
      name: {
        value: "",
        valid: false,
        errorMessage: "",
        touched: false,
        validators: [required],
      },
      formIsValid: false,
    },
  };

  inputChangeHandler = (input, value) => {
    this.setState((prevState) => {
      let isValid = true;
      for (const validator of prevState.signupForm[input].validators) {
        isValid = isValid && validator(value);
      }
      const updatedForm = {
        ...prevState.signupForm,
        [input]: {
          ...prevState.signupForm[input],
          valid: isValid,
          value: value,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }
      return {
        signupForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        signupForm: {
          ...prevState.signupForm,
          [input]: {
            ...prevState.signupForm[input],
            touched: true,
          },
        },
      };
    });
  };

  render() {
    return (
      <Auth>
        <form onSubmit={(e) => this.props.onSignup(e, this.state)}>
          <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--negative-gap-attr">
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
              <Input
                id="email"
                label="آدرس ایمیل"
                type="email"
                control="input"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "email")}
                value={this.state.signupForm["email"].value}
                valid={this.state.signupForm["email"].valid}
                touched={this.state.signupForm["email"].touched}
              />
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
              <Input
                id="name"
                label="نام و نام خانوادگی"
                type="text"
                control="input"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "name")}
                value={this.state.signupForm["name"].value}
                valid={this.state.signupForm["name"].valid}
                touched={this.state.signupForm["name"].touched}
              />
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-12">
              <Input
                id="password"
                label="رمز عبور"
                type="password"
                control="input"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "password")}
                value={this.state.signupForm["password"].value}
                valid={this.state.signupForm["password"].valid}
                touched={this.state.signupForm["password"].touched}
              />
            </div>
          </div>
          <Button design="raised" type="submit" loading={this.props.loading}>
            ثبت نام
          </Button>
        </form>
      </Auth>
    );
  }
}

export default Signup;
